import { Component, computed, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Case } from '@models';
import { CaseService, NotificationService, TitleService } from '@services';

@Component({
  selector: 'app-case-form',
  imports: [
    ReactiveFormsModule,
    RouterModule,

    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
  ],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
})
export class CaseFormComponent {
  route = inject(ActivatedRoute);
  router = inject(Router);
  caseService = inject(CaseService);
  notificationService = inject(NotificationService);
  titleService = inject(TitleService);

  case = signal<Case | undefined>(this.route.snapshot.data['case']);
  form = computed<FormGroup>(() => {
    const c = this.case();
    return new FormGroup({
      title: new FormControl(c?.title || '',
        [Validators.required]),
      date: new FormControl(c?.date ? new Date(c.date) : new Date(),
        [Validators.required]),
      area: new FormControl(c?.area || null,
        [Validators.required]),
      comment: new FormControl(c?.comment || null),
      description: new FormControl(c?.description || null),
      number: new FormControl(c?.number || null),
    });
  });

  constructor() {
    const c = this.case();
    if (c) {
      this.titleService.setTitle("Edit", c.title);
    }
  }

  save() {
    const formValue = this.form().value;
    const c = {
      id: this.case()?.id,
      title: formValue.title,
      date: formValue.date,
      area: formValue.area || undefined,
      description: formValue.description || undefined,
      comment: formValue.comment || undefined,
      number: formValue.number || undefined,
    } as Case;

    const fn = c.id ? this.caseService.update(c) : this.caseService.create(c);
    fn.subscribe({
      next: (result: Case) => {
        this.router.navigate(['placename', 'case', result.id, 'edit'])
          .finally(() => {
            this.form().markAsPristine();
          });
      },
      error: (err) => {
        console.error(err);
        if (err.status === 409) {
          this.notificationService.warning('Provided case number is already taken.');
        } else {
          this.notificationService.error('Failed to save changes.');
        }
      }
    });
  }

}
